module.exports = __webpack_public_path__ + "img/depmap_svg_V103.b3422c0d.svg";